jQuery(document).ready(function($) {


    var video = $('#heroic-video');
    var video_src = video.find('source').attr('src');
    var WindowWidth = $(window).width();

    var large = 'mtc_promo.mp4';
    var small = 'mtc_promo_small.mp4';

    if (WindowWidth < 480) {
        //It is a small screen
        video.attr('src', video_src + small);
    } else {
        //It is a big screen or desktop
        video.attr('src', video_src + large);
    }

    $('[data-tooltip]').each(function() {
        var tooltip = $(this).data('tooltip');

        $(this).append('<span>'+tooltip+'</span>');
    });

    // alert check and switch
    var alert = 0;
    function alertStatus() {
        alert = Cookies.get('notification');
        if ( alert === undefined || alert === 0 ) {
            Cookies.set('notification', 'visible', { expires: 2 } );
        }
    }
    function alertShow() {
        $('.alert').addClass('visible');
        Cookies.set('notification', 'visible');
    }
    function alertHide() {
        $('.alert').removeClass('visible');
        Cookies.set('notification', 'hidden');
    }
    function alertFirstCheck() {
        alertStatus();
        if ( alert === 'visible' ) {
            alertShow();
        } else if ( alert === 'hidden' ) {
            alertHide();
        }
    }
    alertFirstCheck();
    function alertSwitch() {
        alertStatus();
        if ( alert === 'visible' ) {
            alertHide();
        } else if ( alert === 'hidden' ) {
            alertShow();
        }
    }
    $('.alert-accept').on('click', function() {
        alertSwitch();
    });

    $('.carousel').flickity({
        imagesLoaded: true,
        lazyLoad: true
    });

    $('.blocks-gallery-grid').flickity({
        imagesLoaded: true,
        lazyLoad: true,
        contain: true,
        groupCells: false,
        adaptiveHeight: true,
        pageDots: false
    });
    
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    $(window).on('load resize', function() {
        var vh = $(window).innerHeight() * 0.01;
        $('html').get(0).style.setProperty('--vh', vh + 'px');
    });

    $('.list-note > li').each( function(n) {
        $(this).wrapInner('<span></span>');
        $(this).on('click', function() {
            if ( $(this).hasClass('is-checked') ) {
                $(this).removeClass('is-checked');
            } else {
                $(this).addClass('is-checked');
            }
        });

        $(this).attr('id','item-'+n);
        n++;
    });

    // Topper (nav scroll) 
    $(window).on('scroll', function() {
        var wS = $(window).scrollTop(),
            wH = $(window).height() / 2;
        
        if ( wS > wH ) {
            $('header').addClass('is-scrolled');
        }  else {
            $('header').removeClass('is-scrolled');
        }
    });
   

    // Data attribute image
    $('[data-src]').not('img').each(function() {
        var attr = $(this).attr('data-src');
        if (typeof attr !== typeof undefined && attr !== false) {
            $(this).css('background-image', 'url('+attr+')');
        }
    });

    $(function() {
        $('.lazy').lazy({
            combined: true,
            afterLoad: function(element) {
                element.addClass('loaded');
            }
        });
    });

    // Navigation toggle
    $('.nav-toggle').on('click', function(e) {
        e.preventDefault();
        var header = $('header');
        var toggle = $(this);

        if ( header.hasClass('is-active') ) {
            toggle.removeClass('is-active');
            header.removeClass('is-active');
        } else {
            toggle.addClass('is-active');
            header.addClass('is-active');
        }  
    });

    // Data attribute href
    $('[data-href]').each(function() {
        var attr = $(this).attr('data-href');
        if (typeof attr !== typeof undefined && attr !== false) {
            $(this).click(function() {
                window.location = attr;
            });
        }
    });

    // Smooth scroll
    $('a[href*="#"]').on('click', function (e) {
        if( $(this).is('[class*="anchor"]') ) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $($(this).attr('href')).offset().top + (-60)
            }, 500, 'swing');
        }
    });

    // Notification
    $('.notification-toggle').on('click', function(e) {
        e.preventDefault();
        var notification = $('.notification');
        if ( notification.hasClass('is-active') ) {
            $(notification).removeClass('is-active');
        } else {
            $(notification).addClass('is-active');
        }
    });

    $('.notification-button').on('click touchstart', function(e) {
        if ($(this).attr('href') == '') {
            // e.preventDefault();

            var $this = $(this),
            $href = $this.data('link');

            $(this).text('Downloaden');
            $(this).attr('href',$href);
        }
    });

    // Cards
    $('.cards.is-candidates .card').on('click', function(e) {
        e.preventDefault();
        var $this = $(this),
        id = $this.data('id');

        $('#card-' + id).addClass('is-active');
    });

    $('.card-data').click(function() {
        $(this).removeClass('is-active');
    });

    // Tabs
    $( function() {
        $('.tabs .tab').on('click', function(e) {
            e.preventDefault();

            var $this = $(this),
            id = $this.data('id');

            $('.tabs-data .is-active').removeClass('is-active');
            $('.tabs .is-active').removeClass('is-active');

            $(this).addClass('is-active');
            $('#tab-' + id).addClass('is-active');
        });
    });

    $('.more').on('click', function () {
        var txt = $('.content').is(':visible') ? 'Lees meer' : 'Lees minder';
        $('.more').text(txt);
        $(this).next('.content').slideToggle(200);
    });
});